module.exports = __webpack_public_path__ + "static/media/person-outline.8cbbe6c3.svg";